<template>
  <div class="matched">
    <p v-if="isEmptyResult">Услуги не найдены</p>
    <ul v-else class="matched__items">
      <li
        class="matched__item"
        v-bind:class="{ 'no-price-name': !showPriceName }"
        v-for="{ service } in matchedServices"
        v-bind:key="service.id"
      >
        <button class="matched__item__button" type="button" v-on:click="onSelectMatchedService(service, $event); onSelectSetColor($event)">
          <span>{{ service.name }}</span>
        </button>
        <button
          v-if="showPriceName"
          class="matched__item__button"
          type="button"
          v-on:click="onSelectMatchedService(service, $event); onSelectSetColor($event)">
          <span>{{ service.priceName }}</span>
        </button>
        <button
          class="matched__item__button"
          type="button"
          v-on:click="onSelectMatchedService(service, $event); onSelectSetColor($event)">
          <span>{{ service.categoryName }}</span>
        </button>
        <the-rub v-bind:show-kop="$options.SHOW_KOP_AUTO" v-bind:kop="service.cost" currency="руб" />
      </li>
    </ul>
  </div>
</template>

<script>
import TheRub, { SHOW_KOP_AUTO } from '@/components/TheRub.vue';

/**
 * @description Список подходящих услуг.
 * @type {Vue}
 */
export default {
  components: {
    TheRub,
  },
  SHOW_KOP_AUTO,
  computed: {
    /**
     * @description Результатов нет.
     * @returns {boolean}
     */
    isEmptyResult() {
      return (
        this.value
        && this.isAwaitLoadingMatchedServices === false
        && this.matchedServiceList.length === 0
        && this.searchInputViolations.length === 0
      );
    },
    /**
     * @description Подходящие услуги.
     * @returns {Object[]}
     */
    matchedServices() {
      return this.matchedServiceList.map((service) => ({
        service,
        isSelected: this.selectedServices.contains(service),
      }));
    },
  },
  methods: {
    /**
     * @description Обработать выбор услуги из списка подходящих.
     * @type {Object}  service Услуга.
     * @type {boolean} value   Выбрана.
     * @returns {void}
     */
    onSelectMatchedService(service) {
      this.$emit('select-service', service);
    },
    /**
     * @description Изменить цвет выбранной услуги на синий.
     * @param {Object} evt     Событие.
     * @returns {void}
     */
    onSelectSetColor(evt) {
      const currentService = evt.target;
      currentService.classList.add('selected');
    },
  },
  name: 'MatchedServiceList',
  props: {
    /**
     * @description Подходящие услуги.
     * @type {Array}
     */
    matchedServiceList: { required: true, type: Array },
    /**
     * @description Выбранные услуги.
     * @type {Object}
     */
    selectedServices: { required: true, type: Object },
    /**
     * @description Показывать наименование прайса.
     * @type {Boolean}
     */
    showPriceName: { default: () => true, type: Boolean },
  },
};
</script>

<style scoped lang="scss">

.matched {
  width: 100%;
  margin-bottom: 25px;
  &__items {
    display: grid;
    row-gap: 8px;
    padding: 0;
    list-style: none;
  }

  &__item {
    display: grid;
    grid-template-columns: auto 200px 100px 100px;
    column-gap: 10px;
    @media screen and (min-width: 481px) {
      &.no-price-name {
        grid-template-columns: 1fr 160px 100px;
      }
    }
    &__button {
      max-width: 400px;
      text-align: left;
      align-content: start;
      span {
        display: inline-block;
        height: 100%;
      }
      span.selected {
        color: #0569ac;
      }
      @media (hover: hover) {
        &:hover {
          color: #0076C4;
        }
      }
      &:active {
        color: #0569ac;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .matched {
    &__items {
      gap: 5px;
    }
    &__item {
      grid-template: 2fr / 1fr;
      border-bottom: 1px solid rgba(144, 160, 183, 0.7);
      gap: 4px;
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
